var app = angular.module('leonardo');

var WPFormDateRanges = function(FilterService, $rootScope, $timeout) {
  return {
    restrict: 'A',
    require: ['^form','ngModel'],
    scope: {
      label: '@',
      inline: '@',
      placeholder: '@',
      startDate: '@',
      endDate: '@',
      start: '=?',
      end: '=?',
      filter: '@'
    },
    templateUrl: 'views/templates/form/form-date-ranges.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.date_range = '';
      scope.init = false;

      scope.options = [
        {id:'today', name: 'Today'},
        {id:'yesterday', name: 'Yesterday'},
        {id:'last_week', name: 'Last week'},
        {id:'last_month', name: 'Last month'},
        {id:'last_3_months', name: 'Last 3 months'},
        {id:'last_year', name: 'Last year'},
        {id:'last_7_days', name: 'Last 7 days'},
        {id:'last_30_days', name: 'Last 30 days'},
        {id:'last_90_days', name: 'Last 90 days'},
        {id:'last_120_days', name: 'Last 120 days'},
        {id:'last_12_months', name: 'Last 12 months'}
      ];

      scope.setDates = function() {
        var today = new Date();
        var disable = true;
        var date = moment(today);
        if (scope.filter) {
          FilterService.setFilter(scope.filter, scope.date_range);
          switch (scope.date_range) {
            case 'today':
              FilterService.setFilter(scope.startDate, date.format('YYYY-MM-DD'), true);
              FilterService.setFilter(scope.endDate, date.format('YYYY-MM-DD'), true);
              break;
            case 'yesterday':
              date = moment(today).subtract(1, 'days');
              FilterService.setFilter(scope.startDate, date.format('YYYY-MM-DD'), true);
              FilterService.setFilter(scope.endDate, date.format('YYYY-MM-DD'), true);
              break;
            case 'last_week':
              date = moment(today).startOf('week');
              FilterService.setFilter(scope.startDate, date.subtract(7, 'days').format('YYYY-MM-DD'), true);
              FilterService.setFilter(scope.endDate, date.add(6, 'days').format('YYYY-MM-DD'), true);
              break;
            case 'last_month':
              date = moment(today).startOf('month');
              FilterService.setFilter(scope.startDate, date.subtract(1, 'months').format('YYYY-MM-DD'), true);
              FilterService.setFilter(scope.endDate, date.add(1, 'months').subtract(1,'days').format('YYYY-MM-DD'), true);
              break;
            case 'last_3_months':
              date = moment(today).startOf('month');
              FilterService.setFilter(scope.startDate, date.subtract(3, 'months').format('YYYY-MM-DD'), true);
              FilterService.setFilter(scope.endDate, date.add(3, 'months').subtract(1,'days').format('YYYY-MM-DD'), true);
              break;
            case 'last_year':
              date = moment(today).startOf('year');
              FilterService.setFilter(scope.startDate, date.subtract(1, 'years').format('YYYY-MM-DD'), true);
              FilterService.setFilter(scope.endDate, date.add(1, 'years').subtract(1,'days').format('YYYY-MM-DD'), true);
              break;
            case 'last_7_days':
              FilterService.setFilter(scope.startDate, date.subtract(6, 'days').format('YYYY-MM-DD'), true);
              FilterService.setFilter(scope.endDate, date.add(6, 'days').format('YYYY-MM-DD'), true);
              break;
            case 'last_30_days':
              FilterService.setFilter(scope.startDate, date.subtract(29, 'days').format('YYYY-MM-DD'), true);
              FilterService.setFilter(scope.endDate, date.add(29, 'days').format('YYYY-MM-DD'), true);
              break;
            case 'last_90_days':
              FilterService.setFilter(scope.startDate, date.subtract(89, 'days').format('YYYY-MM-DD'), true);
              FilterService.setFilter(scope.endDate, date.add(89, 'days').format('YYYY-MM-DD'), true);
              break;
            case 'last_120_days':
              FilterService.setFilter(scope.startDate, date.subtract(119, 'days').format('YYYY-MM-DD'), true);
              FilterService.setFilter(scope.endDate, date.add(119, 'days').format('YYYY-MM-DD'), true);
              break;
            case 'last_12_months':
              date = moment(today).startOf('month');
              FilterService.setFilter(scope.startDate, date.subtract(12, 'months').format('YYYY-MM-DD'), true);
              FilterService.setFilter(scope.endDate, date.add(12, 'months').subtract(1, 'days').format('YYYY-MM-DD'), true);
              break;
            default:
              if (scope.filter) {
                FilterService.removeFilter(scope.filter);
              }
              disable = false;
              break;
          }
          $timeout(function() {
            $rootScope.$broadcast('value-date-range:status-changed', [scope.startDate, scope.endDate], disable);
            $rootScope.$broadcast('filter-date-range:filter-changed', scope.startDate, FilterService.getFilter(scope.startDate), disable);
            $rootScope.$broadcast('filter-date-range:filter-changed', scope.endDate, FilterService.getFilter(scope.endDate), disable);
          }, 100);
        }
        else {
          switch (scope.date_range) {
            case 'today':
              scope.start = date.format('YYYY-MM-DD');
              scope.end = date.format('YYYY-MM-DD');
              break;
            case 'yesterday':
              date = moment(today).subtract(1, 'days');
              scope.start = date.format('YYYY-MM-DD');
              scope.end = date.format('YYYY-MM-DD');
              break;
            case 'last_week':
              date = moment(today).startOf('week');
              scope.start = date.subtract(7, 'days').format('YYYY-MM-DD');
              scope.end = date.add(6, 'days').format('YYYY-MM-DD');
              break;
            case 'last_month':
              date = moment(today).startOf('month');
              scope.start = date.subtract(1, 'months').format('YYYY-MM-DD');
              scope.end = date.add(1, 'months').subtract(1,'days').format('YYYY-MM-DD');
              break;
            case 'last_3_months':
              date = moment(today).startOf('month');
              scope.start = date.subtract(3, 'months').format('YYYY-MM-DD');
              scope.end = date.add(3, 'months').subtract(1,'days').format('YYYY-MM-DD');
              break;
            case 'last_year':
              date = moment(today).startOf('year');
              scope.start = date.subtract(1, 'years').format('YYYY-MM-DD');
              scope.end = date.add(1, 'years').subtract(1,'days').format('YYYY-MM-DD');
              break;
            case 'last_7_days':
              scope.end = date.format('YYYY-MM-DD');
              scope.start = date.subtract(6, 'days').format('YYYY-MM-DD');
              break;
            case 'last_30_days':
              scope.end = date.format('YYYY-MM-DD');
              scope.start = date.subtract(29, 'days').format('YYYY-MM-DD');
              break;
            case 'last_90_days':
              scope.end = date.format('YYYY-MM-DD');
              scope.start = date.subtract(89, 'days').format('YYYY-MM-DD');
              break;
            case 'last_120_days':
              scope.end = date.format('YYYY-MM-DD');
              scope.start = date.subtract(119, 'days').format('YYYY-MM-DD');
              break;
            case 'last_12_months':
              date = moment(today).startOf('month');
              scope.start = date.subtract(12, 'months').format('YYYY-MM-DD');
              scope.end = date.add(12, 'months').subtract(1, 'days').format('YYYY-MM-DD');
              break;
            default:
              disable = false;
              break;
          }
          $timeout(function() {
            $rootScope.$broadcast('value-date-range:status-changed', [scope.startDate, scope.endDate], disable);
          }, 100);
        }
      };

      scope.$on('filter-service:filter-changed', function($event, key, value) {
        if (key === scope.filter) {
          if (!angular.equals(value, scope.date_range)) {
            if (value) {
              scope.date_range = value;
            }
            else {
              scope.date_range = '';
            }
          }
        }
      });

      scope.$on('filter-service:filter-removed', function($event, key) {
        if (key === scope.filter) {
          scope.date_range = '';
        }
      });

      scope.$watch('date_range', function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue) || !scope.init) {
          scope.ngModelCtrl.$setViewValue(newValue);
          scope.setDates();
          scope.init = true;
        }
      });

      scope.ngModelCtrl.$render = function() {
        scope.date_range = scope.ngModelCtrl.$modelValue;
        if (scope.filter) {
          scope.date_range = FilterService.getFilter(scope.filter);
        }
      };

      scope.$on('$destroy', function() {
        $rootScope.$broadcast('value-date-range:status-changed', [scope.startDate, scope.endDate], false);
      });
    }
  };
};

app.directive('wpFormDateRanges', ['FilterService', '$rootScope', '$timeout', WPFormDateRanges]);
